(() => {
  'use strict';
  const products = new Set(['8995952623902', '9008860889374', '9021563011358', '9014618161438']);
  const addonVariant = '60393975283998';
  let busy = false;
  let failed = false;
  let lastForm = null;
  const root = window.Shopify?.routes?.root || '/';
  function announce(message, form) {
    const host = form || lastForm || document.querySelector('main');
    if (!host) return;
    let status = host.querySelector('[data-btx-cart-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.btxCartStatus = '';
      status.setAttribute('role', 'status');
      status.style.cssText = 'padding:12px;color:inherit;border:1px solid currentColor;';
      host.prepend(status);
    }
    if (status.textContent !== message) status.textContent = message;
  }
  function stop(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  function planUpdate(cart, row, quantity) {
    if (!Array.isArray(cart.items) || !products.has(row.product)) throw new Error('Invalid cart');
    const bases = cart.items.filter(item => String(item.product_id) === row.product && String(item.properties?._gpo_product_group || '') === row.group && item.properties?.sides === 'Front + Back');
    if (bases.length !== 1) throw new Error('The customized item changed');
    const base = bases[0];
    if (row.stock !== undefined && row.stock !== '') {
      const inventory = Number(row.stock);
      if (!Number.isSafeInteger(inventory)) throw new Error('Unable to confirm available stock');
      const otherQuantity = cart.items.filter(item => item.key !== base.key && String(item.variant_id || item.id) === String(base.variant_id || base.id)).reduce((total, item) => total + item.quantity, 0);
      const maximum = Math.max(0, inventory - otherQuantity);
      if (quantity > maximum) {
        const error = new Error('Quantity exceeds available stock');
        error.customerMessage = `Only ${maximum} of this color can be assigned to this item with the other quantities already in your cart. Your cart has not changed.`;
        throw error;
      }
    }
    const children = cart.items.filter(item => String(item.variant_id || item.id) === addonVariant && String(item.properties?._gpo_parent_product_group || '') === row.group && item.properties?._gpo_field_name === 'sides');
    if (children.length !== 1) throw new Error('The engraving add-on could not be matched');
    const child = children[0];
    if (Object.keys(child.properties || {}).some(key => ['_gpo_one_time_charge', '_gpo_quantity_fixed', '_gpo_quantity_dynamic', '_gpo_quantity_mix', '_gpo_per_character'].includes(key))) throw new Error('Unexpected engraving quantity rule');
    return { base, child, updates: { [base.key]: quantity, [child.key]: quantity } };
  }
  async function change(row, quantity, form, control) {
    busy = true;
    let mutationStarted = false;
    lastForm = form;
    announce('Updating your drinkware and engraving together…', form);
    try {
      const currentResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!currentResponse.ok) throw new Error('Unable to read the cart');
      const plan = planUpdate(await currentResponse.json(), row, quantity);
      mutationStarted = true;
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: plan.updates })
      });
      if (!response.ok) throw new Error('The cart update was not accepted');
      const updated = await response.json();
      const bases = updated.items.filter(item => String(item.product_id) === row.product && String(item.properties?._gpo_product_group || '') === row.group);
      const children = updated.items.filter(item => String(item.variant_id || item.id) === addonVariant && String(item.properties?._gpo_parent_product_group || '') === row.group && item.properties?._gpo_field_name === 'sides');
      const complete = quantity === 0 ? bases.length === 0 && children.length === 0 : bases.length === 1 && children.length === 1 && bases[0].quantity === quantity && children[0].quantity === quantity;
      if (!complete) throw new Error('The quantities did not match');
      failed = false;
      window.location.reload();
    } catch (error) {
      failed = failed || mutationStarted;
      busy = false;
      if (!mutationStarted && control?.dataset.currentValue !== undefined) control.value = control.dataset.currentValue;
      announce(error.customerMessage || (mutationStarted ? 'We could not confirm the drinkware and engraving quantities. Please try the quantity change again before checking out.' : 'Your cart was not changed. Please reload to confirm the available quantity and try again.'), form);
      console.error('[BTX drinkware cart]', error);
    }
  }
  function onControl(event) {
    if (!(event.target instanceof Element)) return;
    const control = event.type === 'change' ? event.target.closest('.quantity-selector:not(.quantity-selector--product) .quantity-selector__value') : event.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"], .line-item__quantity-remove, .mini-cart__quantity-remove');
    if (!control) return;
    if (control.closest('[data-btx-cart-addon]')) { stop(event); announce('Change the drinkware quantity to update its back-side engraving.', control.closest('form')); return; }
    if (busy) { stop(event); return; }
    const row = control.closest('[data-btx-cart-key]');
    if (!row) return;
    stop(event);
    const rawQuantity = event.type === 'change' ? control.value : control.dataset.quantity;
    const quantity = typeof rawQuantity === 'string' && rawQuantity.trim() !== '' ? Number(rawQuantity) : NaN;
    const form = control.closest('form');
    if (!Number.isSafeInteger(quantity) || quantity < 0) { if (control.dataset.currentValue !== undefined) control.value = control.dataset.currentValue; announce('Enter a whole-number quantity of zero or more. Your cart has not changed.', form); return; }
    if (!failed && event.type === 'change' && quantity === Number(control.dataset.currentValue)) return;
    change({ key: row.dataset.btxCartKey, group: row.dataset.btxCartGroup, product: row.dataset.btxCartProduct, stock: row.dataset.btxCartStock }, quantity, form, control);
  }
  function guardCheckout(event) {
    if ((!busy && !failed) || !(event.target instanceof Element)) return;
    const checkout = event.type === 'submit' ? event.target.matches('form[action$="/cart"], form[action$="/checkout"]') : event.target.closest('[name="checkout"], a[href*="/checkout"], .shopify-payment-button, .additional-checkout-buttons');
    if (!checkout) return;
    stop(event);
    announce(busy ? 'Please wait while your drinkware and engraving update.' : 'Please resolve the drinkware quantity update before checking out.', lastForm);
  }
  window.addEventListener('click', guardCheckout, true);
  window.addEventListener('submit', guardCheckout, true);
  window.addEventListener('click', onControl, true);
  window.addEventListener('change', onControl, true);
})();
